import { useMutation } from "@tanstack/react-query";

import { login, logout, register } from "@/api/auth";
import { useAuthStore } from "@/store/authStore";
import type { LoginRequest, LogoutRequest, RegisterRequest } from "@/api/types";

export function useAuth() {
  const store = useAuthStore();

  const loginMutation = useMutation({
    mutationFn: (payload: LoginRequest) => login(payload),
    onSuccess: (response) => {
      store.setSession({
        accessToken: response.access_token,
        refreshToken: response.refresh_token,
        expiresIn: response.expires_in,
        deviceId: response.device_id,
        user: response.user,
        tenant: response.tenant,
      });
    },
  });

  const registerMutation = useMutation({
    mutationFn: (payload: RegisterRequest) => register(payload),
    onSuccess: (response) => {
      store.setSession({
        accessToken: response.access_token,
        refreshToken: response.refresh_token,
        expiresIn: response.expires_in,
        deviceId: response.device_id,
        user: response.user,
        tenant: response.tenant,
      });
    },
  });

  const logoutMutation = useMutation({
    mutationFn: (payload: LogoutRequest) => logout(payload),
    onSettled: () => {
      store.clearSession();
    },
  });

  return {
    ...store,
    loginMutation,
    registerMutation,
    logoutMutation,
  };
}
